module.exports = __webpack_public_path__ + "static/media/c31-connect.8dd56796.png";